import React, { Fragment } from "react";
import MediaDialog from "../../creator-application/common/MediaDialog";
import DialogContentText from "@mui/material/DialogContentText";

import Button from "@mui/material/Button";

const RemoveModuleDialog = props => {
  const { module, open, handleClickClose, handleModuleRemove } = props;

  return (
    <MediaDialog
      open={open}
      title="Do you want to remove this module group?"
      content={
        <Fragment>
          <DialogContentText>
            Module Name: {module.moduleName}
          </DialogContentText>
          <DialogContentText>Module ID: {module.moduleId}</DialogContentText>
        </Fragment>
      }
      actions={
        <Fragment>
          <Button onClick={handleClickClose}>Cancel</Button>
          <Button
            variant="contained"
            onClick={() => handleModuleRemove(module.moduleId)}
          >
            Remove
          </Button>
        </Fragment>
      }
    />
  );
};

export default RemoveModuleDialog;
